// extracted by mini-css-extract-plugin
module.exports = {"detailContact":"DetailContact_detailContact__gZkcc","table":"DetailContact_table__2I9z6","key":"DetailContact_key__3Avlz","value":"DetailContact_value__3WRFY"};